(() => {
  const root = document.querySelector('[data-gp-product]');
  if (!root) return;

  const money = (cents) => (window.Shopify && Shopify.formatMoney)
    ? Shopify.formatMoney(cents)
    : `$${(cents / 100).toFixed(2).replace(/\.00$/, '')}`;

  const header = document.querySelector('.section-header, header.site-header, #shopify-section-header, [id$="__header"]');
  const setHeaderOffset = () => {
    const h = header ? Math.round(header.getBoundingClientRect().bottom) : 0;
    root.style.setProperty('--gp-header', `${Math.max(0, h)}px`);
  };
  setHeaderOffset();
  window.addEventListener('resize', setHeaderOffset, { passive: true });

  const track = root.querySelector('[data-track]');
  const count = root.querySelector('[data-count]');
  if (track && count) {
    track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / track.clientWidth) + 1;
      count.textContent = String(Math.min(i, [...track.children].filter((c) => !c.classList.contains('is-off')).length));
    }, { passive: true });
  }

  const more = root.querySelector('[data-more]');
  if (more) more.addEventListener('click', () => { root.querySelector('[data-gallery]').classList.add('is-open'); more.remove(); });

  // Color photos: each color's variants point at the first photo of that color's block.
  // Show that block (plus photos shared by all colors) when a color is picked.
  const gallery = root.querySelector('[data-gallery]');
  const slides = gallery ? [...gallery.querySelectorAll('[data-pos]')] : [];
  const variantsForGallery = JSON.parse(root.querySelector('[data-variants]').textContent);
  const starts = [...new Set(variantsForGallery.map((v) => v.featured_media && v.featured_media.position).filter(Boolean))].sort((a, b) => a - b);
  const maxPos = slides.length ? Math.max(...slides.map((s) => +s.dataset.pos)) : 0;
  const singles = starts.length > 1 && starts.every((s, i) => i === starts.length - 1 || starts[i + 1] === s + 1);
  // Photos before the first color's main photo belong to the first color; each block runs to the next color's main photo.
  // If every color has a single main photo followed by mixed extras, order can't tell colors apart: only lead with the main photo.
  const groupOf = (start) => {
    if (!start || starts.length < 2) return null;
    const i = starts.indexOf(start); if (i < 0) return null;
    if (singles) return { start, end: start, lead: true };
    const from = i === 0 ? 1 : start;
    const end = i < starts.length - 1 ? starts[i + 1] - 1 : maxPos;
    return { start, from, end };
  };
  let shownStart = null;
  function showColor(variant) {
    if (!gallery || !slides.length) return;
    const g = groupOf(variant && variant.featured_media && variant.featured_media.position);
    if (!g) return;
    if (g.start === shownStart) return;
    shownStart = g.start;
    slides.forEach((s) => track.appendChild(s)); // back to the original order before leading with this color
    const visible = [];
    slides.forEach((s) => {
      const pos = +s.dataset.pos;
      const on = g.lead ? true : (pos >= g.from && pos <= g.end);
      s.classList.toggle('is-off', !on);
      s.classList.remove('is-lead', 'is-extra');
      if (on) visible.push(s);
    });
    // lead with the color's main photo
    const lead = slides.find((s) => +s.dataset.pos === g.start);
    if (lead && visible[0] !== lead) { track.insertBefore(lead, visible[0]); visible.splice(visible.indexOf(lead), 1); visible.unshift(lead); }
    visible.forEach((s, i) => { if (i === 0) s.classList.add('is-lead'); if (i >= 5) s.classList.add('is-extra'); });
    gallery.classList.add('gp-js');
    const total = root.querySelector('[data-total]'); if (total) total.textContent = String(visible.length);
    const mc = root.querySelector('[data-more-count]'); if (mc) mc.textContent = String(visible.length);
    const mb = root.querySelector('[data-more]'); if (mb) mb.hidden = visible.length <= 5;
    if (track) track.scrollLeft = 0;
    if (count) count.textContent = '1';
  }

  const form = root.querySelector('[data-form]');
  const idInput = root.querySelector('[data-variant-id]');
  const addBtn = root.querySelector('[data-add]');
  const addLabel = root.querySelector('[data-add-label]');
  const msg = root.querySelector('[data-msg]');
  const price = root.querySelector('[data-price]');
  const bar = root.querySelector('[data-bar]');
  const barBtn = root.querySelector('[data-bar-add]');
  const barPrice = root.querySelector('[data-bar-price]');
  const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
  const outLabel = root.hasAttribute('data-soon') ? 'Coming soon' : 'Sold out';

  const selected = () => [...root.querySelectorAll('[data-option]')].map((f) => {
    const checked = f.querySelector('input:checked');
    return checked ? checked.value : null;
  });

  function priceHtml(v) {
    const sale = v.compare_at_price && v.compare_at_price > v.price;
    return { sale, html: `<span>${money(v.price)}</span>${sale ? `<s>${money(v.compare_at_price)}</s>` : ''}` };
  }

  function markAvailability(current) {
    root.querySelectorAll('[data-option]').forEach((fieldset, index) => {
      fieldset.querySelectorAll('input').forEach((input) => {
        const probe = [...current];
        probe[index] = input.value;
        const match = variants.find((v) => v.options.every((o, i) => o === probe[i]));
        input.closest('.gp-pdp__value').classList.toggle('is-out', !match || !match.available);
      });
    });
  }

  function update() {
    const current = selected();
    const variant = variants.find((v) => v.options.every((o, i) => o === current[i]));
    root.querySelectorAll('[data-option]').forEach((f, i) => {
      const label = f.querySelector('[data-option-value]');
      if (label) label.textContent = current[i] || '';
    });
    markAvailability(current);
    if (!variant) {
      addBtn.disabled = true; addLabel.textContent = 'Unavailable';
      if (barBtn) { barBtn.disabled = true; barBtn.textContent = 'Unavailable'; }
      return;
    }
    idInput.value = variant.id;
    showColor(variant);
    const p = priceHtml(variant);
    price.innerHTML = p.html; price.classList.toggle('gp-price--sale', p.sale);
    if (barPrice) { barPrice.innerHTML = `<span>${money(variant.price)}</span>`; barPrice.classList.toggle('gp-price--sale', p.sale); }
    addBtn.disabled = !variant.available;
    const inLabel = root.hasAttribute('data-preorder') ? 'Pre-order' : 'Add to cart';
    addLabel.textContent = variant.available ? inLabel : outLabel;
    if (barBtn) { barBtn.disabled = !variant.available; barBtn.textContent = variant.available ? inLabel : outLabel; }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  root.querySelectorAll('[data-option] input').forEach((input) => input.addEventListener('change', update));
  if (root.querySelector('[data-option]')) markAvailability(selected());
  {
    const cur = selected();
    const v0 = variants.find((v) => v.options.every((o, i) => o === cur[i]));
    if (v0) showColor(v0);
  }

  function say(text, isError) {
    msg.textContent = text;
    msg.classList.toggle('is-error', !!isError);
    msg.hidden = !text;
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (addBtn.disabled) return;
    say('');
    addBtn.disabled = true;
    const before = addLabel.textContent;
    addLabel.textContent = 'Adding…';
    try {
      const res = await fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] }),
      });
      const out = await res.json();
      if (!res.ok) throw new Error(out.description || out.message || 'error');
      document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, detail: { openDrawer: true } }));
      addLabel.textContent = 'Added';
      setTimeout(() => { addLabel.textContent = before; }, 1600);
    } catch (err) {
      say(err.message && err.message !== 'error' ? err.message : "Couldn't add it to your cart. Please try again.", true);
      addLabel.textContent = before;
    } finally {
      addBtn.disabled = false;
    }
  });

  if (bar && 'IntersectionObserver' in window) {
    bar.hidden = false;
    const io = new IntersectionObserver(([entry]) => {
      const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past);
      if (past) setHeaderOffset();
    });
    io.observe(addBtn);
    barBtn.addEventListener('click', () => form.requestSubmit());
  }
})();

(() => {
  // Shopify's installments message lives in a shadow root; balance its lines so the help icon never wraps alone.
  const css = 'p { text-wrap: balance; margin: 0; }';
  const apply = () => document.querySelectorAll('shopify-payment-terms').forEach((el) => {
    const root = el.shadowRoot;
    if (!root || root.querySelector('style[data-gp]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-gp', '');
    style.textContent = css;
    root.appendChild(style);
  });
  let tries = 0;
  const timer = setInterval(() => { apply(); if (++tries > 20) clearInterval(timer); }, 250);
  document.addEventListener('change', () => setTimeout(apply, 300));
})();

